import {Grid} from "@mantine/core";

import {ListRowsProps} from "./types";

import {RemoveRowButton} from "./RemoveRowButton";

import {ListRow} from "./ListRow";
import {useFormikContext} from "formik";

export const ListRows = ({
                             fieldName,
                             remove,
                             getRowElements
                         }: ListRowsProps) => {

    const {
        values,
    } = useFormikContext<any>();

    if (Array.isArray(values[fieldName]) && values[fieldName].length > 0) {

        return values[fieldName].map((row: object, rowIndex: number) => {

            const rowElements = getRowElements(row);

            return (
                <Grid key={rowIndex}>
                    <Grid.Col span={11}>
                        <ListRow fieldName={fieldName} rowIndex={rowIndex} rowElements={rowElements}/>
                    </Grid.Col>
                    <Grid.Col span={1}>
                        <RemoveRowButton remove={remove} rowIndex={rowIndex}/>
                    </Grid.Col>
                </Grid>
            );
        });
    } else {
        return null;
    }
};
